import { render, staticRenderFns } from "./ErrorLogsTable.vue?vue&type=template&id=1029cbc4&scoped=true"
import script from "./ErrorLogsTable.vue?vue&type=script&lang=js"
export * from "./ErrorLogsTable.vue?vue&type=script&lang=js"
import style0 from "./ErrorLogsTable.vue?vue&type=style&index=0&id=1029cbc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1029cbc4",
  null
  
)

export default component.exports